import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type OfflineJobStatus = "idle" | "processing" | "ready" | "error";

interface OfflineJobState {
  status: OfflineJobStatus;
  step: string;
  startTime: number | null;
  jobId: string | null;
  results: Record<string, any>;
  ranks: Record<string, Record<string, any>>;
  firstAvt: string;
  storedData: any | null;
  errorMsg: string;
}

const initialState: OfflineJobState = {
  status: "idle",
  step: "",
  startTime: null,
  jobId: null,
  results: {},
  ranks: {},
  firstAvt: "",
  storedData: null,
  errorMsg: "",
};

export const offlineJobSlice = createSlice({
  name: "offlineJob",
  initialState,
  reducers: {
    startOfflineJob: (state) => {
      state.status = "processing";
      state.step = "Iniciando processamento...";
      state.startTime = Date.now();
      state.jobId = null;
      state.errorMsg = "";
      state.results = {};
      state.ranks = {};
      state.firstAvt = "";
      state.storedData = null;
    },
    setOfflineJobStep: (state, action: PayloadAction<string>) => {
      state.step = action.payload;
    },
    setOfflineJobId: (state, action: PayloadAction<string>) => {
      state.jobId = action.payload;
    },
    offlineJobSucceeded: (
      state,
      action: PayloadAction<{
        results: Record<string, any>;
        ranks: Record<string, Record<string, any>>;
        firstAvt: string;
        storedData: any;
      }>,
    ) => {
      state.status = "ready";
      state.step = "Processamento concluído";
      state.results = action.payload.results;
      state.ranks = action.payload.ranks;
      state.firstAvt = action.payload.firstAvt;
      state.storedData = action.payload.storedData;
    },
    offlineJobFailed: (state, action: PayloadAction<string>) => {
      state.status = "error";
      state.errorMsg = action.payload;
      state.step = "";
    },
    clearOfflineJob: (state) => {
      state.status = "idle";
      state.step = "";
      state.startTime = null;
      state.jobId = null;
      state.errorMsg = "";
      state.results = {};
      state.ranks = {};
      state.firstAvt = "";
      state.storedData = null;
    },
    markOfflineJobViewed: (state) => {
      state.status = "idle";
      state.step = "";
      state.startTime = null;
      state.jobId = null;
      state.errorMsg = "";
    },
  },
});

export const {
  startOfflineJob,
  setOfflineJobStep,
  setOfflineJobId,
  offlineJobSucceeded,
  offlineJobFailed,
  clearOfflineJob,
  markOfflineJobViewed,
} = offlineJobSlice.actions;

export default offlineJobSlice.reducer;
